// extracted by mini-css-extract-plugin
module.exports = {"inner-wrapper":"_1Tg6R","wrapper":"_3pfcx","card-container":"JIV0R"};